import { Dealer } from '../dealers/dealers.model';

export enum PresenceStatus {
  CHECK_IN = 'check-in',
  CHECK_OUT = 'check-out',
  YET_TO_CHECK_IN = 'yet-to-check-in',
}

export interface EmployeeAttendance {
  id: string;
  email: string;
  first_name: string;
  last_name: string;
  profile_image: string | null;
  status: PresenceStatus;
  time: string | null;
  location: string;
}

export interface TourLog {
  id: string;
  check_in: string;
  check_out: string | null;
  tour_purpose: string;
  vehicle_type: string;
  tour_type: string;
  place_to_visit: string;
  opening_km: number;
  closing_km: number | null;
  check_in_image: string;
  check_out_image: string | null;
  employee_selfie: string | null;
  party_visits: PartyVisit[];
  check_in_location: Location;
  check_out_location: Location | null;
}

export interface Location {
  id: string;
  latitude: number;
  longitude: number;
  remaining_battery: number;
  network_strength: string;
  timestamp: string;
  address: string;
}

export interface PartyVisit {
  id: string;
  dealer: Dealer;
  visit_status: string;
  visit_check_in: string | null;
  visit_check_out: string | null;
  check_out_location: Location | null;
  visit_type: string | null;
  visit_type_display: string | null;
  visit_reasons: string[];
  visit_reasons_display: string[];
  visit_remarks: string | null;
  visit_image: string | null;
  follow_up_date: string | null;
  cancel_reason: string | null;
  cancel_reason_display: string | null;
  cancel_remarks: string | null;
  created_at: string;
}

export interface EmployeeAttendanceDetails {
  id: string;
  date: string;
  logs: TourLog[];
  total_worked_hours: string;
}

export interface AttendanceLog {
  id: string;
  name: string;
  date: string;
  route: string;
  opening_km: number;
  closing_km: number | null;
  total_km: number;
  opening_meter_image: string | null;
  closing_meter_image: string | null;
}

export interface DayTimeline {
  date: string;
  segments: {
    checkIn: Date;
    checkOut: Date;
    location?: string;
  }[];
  totalWorked: string;
  isWeekend: boolean;
  isAbsent: boolean;
}
